import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthenticationState {
  isAuthenticated: boolean | null;
  redirectLink: string | null;
  sourceEnabled: boolean;
  lumosEnabled: boolean;
  homeEnabled: boolean;
  oldEnrollmentUrl: string | null;
  mfaEnabled: boolean;
  mfaRequired: boolean;
  mfaConfigured: boolean;
}

const initialState: AuthenticationState = {
  isAuthenticated: false,
  redirectLink: null,
  sourceEnabled: false,
  lumosEnabled: false,
  homeEnabled: false,
  oldEnrollmentUrl: null,
  mfaEnabled: false,
  mfaRequired: false,
  mfaConfigured: false,
};

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setAuthenticated: (state, { payload }: PayloadAction<boolean>) => {
      state.isAuthenticated = payload;
    },
    setRedirectLink: (state, { payload }: PayloadAction<string | null>) => {
      state.redirectLink = payload;
    },
    setSourceEnabled: (state, { payload }: PayloadAction<boolean>) => {
      state.sourceEnabled = payload;
    },
    setLumosEnabled: (state, { payload }: PayloadAction<boolean>) => {
      state.lumosEnabled = payload;
    },
    setHomeEnabled: (state, { payload }: PayloadAction<boolean>) => {
      state.homeEnabled = payload;
    },
    setOldEnrollmentUrl: (state, { payload }: PayloadAction<string | null>) => {
      state.oldEnrollmentUrl = payload;
    },
    setMfaEnabled: (state, { payload }: PayloadAction<boolean>) => {
      state.mfaEnabled = payload;
    },
    setMfaRequired: (state, { payload }: PayloadAction<boolean>) => {
      state.mfaRequired = payload;
    },
    setMfaConfigured: (state, { payload }: PayloadAction<boolean>) => {
      state.mfaConfigured = payload;
    },
  },
});

const { reducer, actions } = authenticationSlice;

// Actions
export const {
  setAuthenticated,
  setRedirectLink,
  setSourceEnabled,
  setLumosEnabled,
  setHomeEnabled,
  setOldEnrollmentUrl,
  setMfaEnabled,
  setMfaRequired,
  setMfaConfigured,
} = actions;

export const authenticationReducer = reducer;
